import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Enquiries } from "./Enquiries/Enquiries";

export const FormsSubmissions = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(query.get("activeTab") || "enquiries");
  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/feedback-submissions?activeTab=${activeTab}`, {
        replace: true,
      });
    }
  }, []);

  const renderActiveTabContent = () => {
    switch (activeTab) {
      // case 'epcApplications':
      //   return <EpcApplications />;
      case "enquiries":
        return <Enquiries />;
      // case 'contests':
      //   return <Contests />;
      default:
        return null;
    }
  };

  const handleTabChange = (newActiveKey: any) => {
    setActiveTab(newActiveKey);
    navigate(`${window.location.pathname}?activeTab=${newActiveKey}`);
  };

  const items = [
    // {
    //   label: "EPC Applications",
    //   key: "epcApplications",
    // },
    {
      label: "Enquiries",
      key: "enquiries",
    },
    // {
    //   label: "Contests",
    //   key: "contests",
    // },
  ];

  return (
    <ContentWrapper
      title={"Feedback Submissions"}
      actionItems={
        activeTab === "epcApplications" && (
          <Button
            onClick={() => {
              navigate("/dedicated/eraman/epc-applications/add");
            }}
            icon={<Icon icon={"lucide:plus"} />}
          >
            Add New EPC
          </Button>
        )
      }
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={handleTabChange}
      ></Tabs>
      {renderActiveTabContent()}
    </ContentWrapper>
  );
};
